import React, { useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import "../../style/popupform.css";
import { Button, Col, Form, Input, Modal, Row } from "antd";
const PopupForm = ({ formData, onSave, onCancel }) => {
  
  const [form] = Form.useForm();

  console.log('sss initialValues formData', formData)

  const initialValues = formData && formData.edited && !formData.generate ? {
    background: formData.background,
    strength: formData.strength,
    direction: formData.direction,
    id: formData.id,
  } : (formData?.[1]?.[0] || formData?.[2]?.[0] || formData?.[3]?.[0] || formData?.[4]?.[0] || formData?.[5]?.[0] || formData?.[6]?.[0] || formData?.[7]?.[0] || formData?.[8]?.[0]) ? formData.generate ? {

    background: `${formData[1]?.[0] || ""} professional with experience in ${formData[2]?.[0] || ""} across ${formData[3]?.[0] || ""} industries`,
    strength: `Strengths in ${formData[4]?.[0] || ""} in order to ${formData[5]?.[0] || ""} by utilizing ${formData[6]?.[0] || ""}`,
    direction: `Motivated by ${formData[7]?.[0] || ""} opportunities in the ${formData[8]?.[0] || ""} industry.`,
    id: formData.id,
  } : {
    background: `${formData[1]?.[0] || ""}  ${formData[2]?.[0] || ""}  ${formData[3]?.[0] || ""}`,
    strength: `${formData[4]?.[0] || ""} ${formData[5]?.[0] || ""} ${formData[6]?.[0] || ""}`,
    direction: `${formData[7]?.[0] || ""} ${formData[8]?.[0] || ""}`,
    id: formData.id,
  } : {
    background: "",
    strength: "",
    direction: "",
    id: formData.id,
  };

  // console.log('sss initialValues', initialValues)

  const onSubmit = (values) => {
    const val = {
      ...values,
      edited: true
    }
    const Id = initialValues.id ? initialValues.id : null
    onSave(val, Id);
    onCancel()
  };

  return (
    <Modal
      title=""
      footer={null}
      visible={true}
      onCancel={onCancel}
      width="590px"
      // closeIcon={<CloseOutlined className="close-icon" />}
    >
      <h2 className="modal-title">Edit Professional Summary</h2>
      <Form form={form} name="professional_summary_form" onFinish={onSubmit} initialValues={initialValues}>

        <Row>
          <Col span={24}>
            <p
              style={{
                textAlign: "left",
                fontSize: "19px",
                fontWeight: "normal",
              }}
              >My Background</p>
            <p>Tool Tip: <span className="tooltip-popup">I’m a [...] with expertise in [list 3-5 areas of functional skills].</span></p>
            <Form.Item
              name="background"
              >
              <Input.TextArea
                name="background"
                style={{
                  backgroundColor: "#F6FAFB",
                  border: "1px solid #CCE6E7",
                }}
                autoSize={{ minRows: 2, maxRows: 5 }}
                className="form-textarea"
                placeholder="Write something here"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <p
              style={{
                textAlign: "left",
                fontSize: "19px",
                fontWeight: "normal",
              }}
              >My Strengths</p>
            <p>Tool Tip: <span className="tooltip-popup">What are you best at? What should someone hire you to do?</span></p>
            <Form.Item
              name="strength"
              >
              <Input.TextArea
                name="strength"
                style={{
                  backgroundColor: "#F6FAFB",
                  border: "1px solid #CCE6E7",
                }}
                autoSize={{ minRows: 2, maxRows: 5}}
                className="form-textarea"
                placeholder="Write something here"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <p
              style={{
                textAlign: "left",
                fontSize: "19px",
                fontWeight: "normal",
              }}
              >My Direction</p>
            <p>Tool Tip: <span className="tooltip-popup">I’m motivated by [list 2-3 role titles] and [2-3 industries].</span></p>
            <Form.Item
              name="direction"
              >
              <Input.TextArea
                name="direction"
                style={{
                  backgroundColor: "#F6FAFB",
                  border: "1px solid #CCE6E7",
                }}
                autoSize={{ minRows: 2, maxRows: 5 }}
                className="form-textarea"
                placeholder="Write something here"
              />
            </Form.Item>
          </Col>
        </Row>

        <div className="button-group">
          <button className="button-secondary" style={{width: "25%"}} onClick={onCancel}>Cancel</button>
          <button className="button-main" htmltype="submit" style={{width: "25%"}}>Save</button>
        </div>

      </Form>

    </Modal>
  );
};

export default PopupForm;
